import { useContext } from 'react';
import {observer} from "mobx-react";
import classNames from 'classnames';

import { AuthenticationController } from "../../backends/YiiRoutes";
import styles from './styles/PoweredByCS.module.scss';
import ClickableLink from "../utilities/ClickableLink";
import Button from "../utilities/Button";
import {StoreContext} from "../../stores/StoreLoader";

const poweredByContainerClassName = classNames({
    [styles.poweredByContainer]: true,
});
const loginButtonClassName = classNames({
    [styles.loginButton]: true,
});

const PoweredBy = observer(props => {
    const {i18nStore, modalStore, userStore, interfaceStore} = useContext(StoreContext);

    function openLogin() {
        modalStore.addModal({
            type: "login",
            size: "lg",
            id: 'login-modal',
        });
    }

    let logoutButton;
    if (interfaceStore.isSchoolBlocks) {
        logoutButton = <ClickableLink className={loginButtonClassName}
                                      href={AuthenticationController.logout(i18nStore.currentOrgSupportedLocale)}>Logout</ClickableLink>;
    } else {
        logoutButton = <Button className={loginButtonClassName} onClick={userStore.logout}>Logout</Button>
    }

    return (
        <div className={poweredByContainerClassName}>
            <div>
                {userStore.id ? logoutButton
                    : <Button className={loginButtonClassName} onClick={openLogin}>Login</Button>}
            </div>
            <small>This website powered by <span>
                {interfaceStore.isSchoolBlocks ? <ClickableLink href={"https://www.schoolblocks.com"}>SchoolBlocks</ClickableLink>
                : <ClickableLink href={"https://www.cleversite.com"}>CleverSite</ClickableLink>}
            </span></small>
        </div>
    )
});

export default PoweredBy;
